import React from "react";

interface BreadCrumbProps {
  currentStep: number;
}

const BreadCrumb: React.FC<BreadCrumbProps> = ({ currentStep }) => {
  return (
    <div className={`pasarella_form-header ${currentStep === 2 ? "is-center" : currentStep === 3 ?"is-right":""}`}>
      <a
        className={`pasarella_box-header-item ${currentStep !== 1 ? "is-codigo" : ""} w-inline-block `}
      >
        <div
          className={`pasarella_box-top ${currentStep >= 1 ? "current" : ""}`}
        >
          Paso 1
        </div>
        <div
          className={`pasarella_box-header-circulo ${
            currentStep >= 1 ? "current" : ""
          }`}
          style={currentStep >= 1 ? { backgroundImage: "url('/documents/d/guest/group-84')" } : undefined}
        ></div>
        <div
          className={`pasarella_box-bottom ${
            currentStep >= 1 ? "current" : ""
          }`}
        >
          Preguntas de validación
        </div>
      </a>
      <div
        className={`pasarella_box-header-line ${
          currentStep + 1 >= 2 ? "current" : ""
        }`}
      ></div>
      <a
        className={`pasarella_box-header-item w-inline-block ${currentStep <= 1 ? "siguient" : ""}`}
      >
        <div
          className={`pasarella_box-top ${currentStep >= 2 ? "current" : ""}`}
        >
          Paso 2
        </div>
        <div
          className={`pasarella_box-header-circulo ${
            currentStep >= 2 ? "current" : ""
          }`}
          style={currentStep >= 2 ? { backgroundImage: "url('/documents/d/guest/group-84')" } : undefined}
        ></div>
        <div
          className={`pasarella_box-bottom ${
            currentStep >= 2 ? "current" : ""
          }`}
        >
          Código de verificación
        </div>
      </a>
      <div
        className={`pasarella_box-header-line ${
          currentStep + 1 > 3 ? "current" : ""
        }`}
      ></div>
      <a
        className={`pasarella_box-header-item ${currentStep !== 3 ? "is-codigo" : ""} w-inline-block`}
      >
        <div
          className={`pasarella_box-top ${currentStep >= 3 ? "current" : ""}`}
        >
          Paso 3
        </div>
        <div
          className={`pasarella_box-header-circulo ${
            currentStep >= 3 ? "current" : ""
          }`}
          style={currentStep >= 3 ? { backgroundImage: "url('/documents/d/guest/group-84')" } : undefined}
        ></div>
        <div
          className={`pasarella_box-bottom ${
            currentStep >= 3 ? "current" : ""
          }`}
        >
          Crear contraseña
        </div>
      </a>
    </div>
  );
};

export default BreadCrumb;
